import HydrationActions from '../actions/hydration';

const initialState = {
    hydrationComplete: false
};

export default (state = initialState, action) => {
    switch (action.type) {
    case HydrationActions.SET_HYDRATION_COMPLETE:
        return { ...state, hydrationComplete: action.hydrationComplete };
    default:
        return state;
    }
};
